<template>
  <div class="page flex-col">
    <div class="group_2 flex-col">
      <div class="box_2 flex-row">
        <span class="text_7" style="cursor: pointer" @click="handleJump('/home')">首页</span>
        <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            src="./../../assets/img/right.webp"
        />
        <span class="text_8" style="cursor: pointer" @click="handleClick(0, true)">加入我们</span>
        <img
            class="thumbnail_2"
            referrerpolicy="no-referrer"
            src="./../../assets/img/right.webp"
        />
        <span class="text_9" style="cursor: pointer" @click="handleClick(0)">企业现状</span>
        <img
            class="thumbnail_3"
            referrerpolicy="no-referrer"
            src="./../../assets/img/right.webp"
        />
        <span class="text_10">销售渠道</span>
      </div>
      <div class="box_3 flex-col">
          <span class="paragraph_1">
            &ensp;&ensp;&ensp;&ensp;一支专业的拓展队伍，常年在外搜寻民办或公办院校计划外包后勤管理的市场；通过严谨的投资逻辑，衡量投资价值；制定专业的商务条款，确保投资回报。
            <br />
            &ensp;&ensp;&ensp;&ensp;优质的品牌库资源和高效的运营团队，可快速填补新增项目市场需要。专业的运营团队，通过功能配套、业态组合等科学合理配置，筛选合作商家，为商家落地、经营提供优质服务。
            <br />
          </span>
        <div class="section_2 flex-col"></div>
      </div>
      <div class="image-text_1 flex-row justify-between" style="cursor: pointer" @click="handleClick(0)">
        <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="./../../assets/img/return.webp"
        />
        <span class="text-group_1">返回</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {
    handleJump(url, data = {}) {
      if (url === this.$route.path) return;
      this.$router.push({
        path: url,
        query: data
      });
      window.scrollTo(0,0);
    },
    handleClick(value, top = false) {
      this.$emit('select', value, top);
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
